document.addEventListener('DOMContentLoaded', () => {

  const links = document.querySelectorAll('.mega-menu-collection');
  const preview = document.querySelector('.mega-menu-preview__inner');

  if (!preview) return;

  links.forEach((link) => {

    link.addEventListener('mouseenter', async function() {

      const handle = this.dataset.handle;

      console.log('Loading collection:', handle);

      try {

        const response = await fetch(
          `/collections/${handle}/products.json?limit=4`
        );

        const data = await response.json();

        preview.innerHTML = '';

        if (!data.products || data.products.length === 0) {
          preview.innerHTML = '<p>No products found.</p>';
          return;
        }

        data.products.forEach((product, index) => {

          const image =
            product.images?.[0]?.src || '';

          const price =
            product.variants?.[0]?.price || '';

          const productHtml = `
            <a
              href="/products/${product.handle}"
              class="mega-preview-product"
              style="
                opacity:0;
                animation:megaFade .4s ease forwards;
                animation-delay:${index * 100}ms;
              "
            >
              <img
                src="${image}"
                alt="${product.title}"
              >

              <div class="mega-preview-title">
                ${product.title}
              </div>

              <div class="mega-preview-price">
                $${price}
              </div>

            </a>
          `;

          preview.insertAdjacentHTML(
            'beforeend',
            productHtml
          );

        });

      } catch (error) {

        console.error(
          'Mega menu error:',
          error
        );

      }

    });

  });

});